import { Chip } from '@mui/material';
import {
  BLUE_50,
  BLUE_500,
  GRAY_200,
  GRAY_900,
  GREEN_500,
  RED_50,
  RED_500,
  WHITE,
  TEAL_50,
  TEAL_500,
  RED_400,
  LIGHT_GREEN_500,
  CYAN_500,
  LIME_500,
  YELLOW_500,
  AMBER_500,
  PURPLE_500,
  BLUE_GRAY_400,
} from '../../constants/Colors';
import { Delete, Edit, CopyAll, Visibility } from '@mui/icons-material';
import { t } from 'i18next';

export interface BakeasyChipProps {
  label?: string;
  clickable?: boolean;
  disabled?: boolean;
  icon?: any;
  type?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  onDelete?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export function BakeasyChip(props: BakeasyChipProps) {
  let backgroundColor: any = 'primary';
  let textColor: any = 'primary';

  switch (props?.type?.toLowerCase() || props?.label?.toLowerCase()) {
    case 'pending':
      textColor = TEAL_500;
      backgroundColor = TEAL_50;
      break;
    case 'approved':
    case 'approve':
    case 'category':
    case 'subcategory':
    case 'status':
    case 'assigned':
    case 'yes':
    case 'reply':
    case 'view_reply':
    case 'view':
    case 'read_reply':
    case 'read':
      textColor = GREEN_500;
      backgroundColor = TEAL_50;
      break;
    case 'rejected':
    case 'reject':
    case 'unassigned':
    case 'no':
    case 'deactive':
    case 'delete':
      textColor = RED_500;
      backgroundColor = RED_50;
      break;
    case 'ongoing':
      textColor = 'info';
      break;
    case 'edit':
    case 'oderered':
    case 'delivered':
    case 'confirm':
    case 'unavailable':
      textColor = BLUE_500;
      backgroundColor = BLUE_50;
      break;
    case 'duplicate':
      textColor = BLUE_500;
      backgroundColor = BLUE_50;
      break;
    case 'cancel':
      textColor = GRAY_900;
      backgroundColor = GRAY_200;
      break;
    case 'temp. unavailable':
      textColor = BLUE_50;
      backgroundColor = BLUE_500;
      break;
    case 'split':
      textColor = GRAY_900;
      backgroundColor = YELLOW_500;
      break;
    case 'processed':
      textColor = WHITE;
      backgroundColor = CYAN_500;
      break;
    case 'new':
      textColor = WHITE;
      backgroundColor = GREEN_500;
      break;
    case 'cancelled':
      textColor = WHITE;
      backgroundColor = RED_400;
      break;
    case 'inproduction':
      textColor = WHITE;
      backgroundColor = TEAL_500;
      break;
    case 'shipped':
      textColor = WHITE;
      backgroundColor = LIGHT_GREEN_500;
      break;
    case 'packed':
      textColor = WHITE;
      backgroundColor = GREEN_500;
      break;
    case 'invoiced':
      textColor = GRAY_900;
      backgroundColor = LIME_500;
      break;
    case 'complete':
    case 'completed':
      textColor = GRAY_900;
      backgroundColor = AMBER_500;
      break;
    case 'backorder':
      textColor = WHITE;
      backgroundColor = PURPLE_500;
      break;
    case 'active':
      textColor = WHITE;
      backgroundColor = GREEN_500;
      break;
    case 'inactive':
      textColor = WHITE;
      backgroundColor = RED_500;
      break;
    case 'sent':
      textColor = WHITE;
      backgroundColor = BLUE_500;
      break;
    case 'read':
      textColor = WHITE;
      backgroundColor = BLUE_GRAY_400;
      break;
    case 'normal':
      textColor = WHITE;
      backgroundColor = BLUE_500;
      break;
    // case 'sent':
    //   textColor = WHITE;
    //   backgroundColor = GREEN_500;
    //   break;
    // case 'read':
    //   textColor = WHITE;
    //   backgroundColor = BLUE_GRAY_400;
    //   break;
    // case 'normal':
    //   textColor = WHITE;
    //   backgroundColor = GREEN_500;
    //   break;
    case 'urgent':
      textColor = WHITE;
      backgroundColor = RED_400;
      break;
    default:
      textColor = GRAY_900;
      backgroundColor = GRAY_200;
      break;
  }

  return (
    <Chip
      sx={{
        margin: 0.1,
        padding: 0.5,
        color: textColor,
        backgroundColor: backgroundColor,
      }}
      size={'small'}
      label={props?.label && t(props?.label.toUpperCase())}
      icon={props?.icon}
      color={'primary'}
      disabled={props?.disabled}
      onClick={props?.onClick}
      onDelete={props?.onDelete}
    />
  );
}

export function BakeasyChipEdit(props: BakeasyChipProps) {
  return <BakeasyChip {...props} icon={<Edit />} label={'EDIT'} />;
}

export function BakeasyChipDelete(props: BakeasyChipProps) {
  return <BakeasyChip {...props} icon={<Delete />} label={'DELETE'} />;
}

export function BakeasyChipDuplicate(props: BakeasyChipProps) {
  return <BakeasyChip {...props} icon={<CopyAll />} label={'DUPLICATE'} />;
}

export function BakeasyChipInprogress(props: BakeasyChipProps) {
  return <BakeasyChip {...props} icon={''} label={'INPROGRESS'} />;
}

export function BakeasyChipBackOrder(props: BakeasyChipProps) {
  return <BakeasyChip {...props} icon={''} label={'BACKORDER'} />;
}

export function BakeasyChipFilterCancel(props: BakeasyChipProps) {
  return <BakeasyChip {...props} type="cancel" />;
}

export function BakeasyChipSent(props: BakeasyChipProps) {
  return <BakeasyChip {...props} label={'SENT'} />;
}

export function BakeasyChipRead(props: BakeasyChipProps) {
  return <BakeasyChip {...props} label={'READ'} />;
}

export function BakeasyChipNew(props: BakeasyChipProps) {
  return <BakeasyChip {...props} label={'NEW'} />;
}

export function BakeasyChipNormal(props: BakeasyChipProps) {
  return <BakeasyChip {...props} label={'NORMAL'} />;
}

export function BakeasyChipUrgent(props: BakeasyChipProps) {
  return <BakeasyChip {...props} label={'URGENT'} />;
}

export function BakeasyChipViewReply(props: BakeasyChipProps) {
  return <BakeasyChip {...props} icon={<Visibility />} />;
}
